import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AddProductApprovalComponent } from '../add-product-approval/add-product-approval.component';
import { studyReportPatientConstant, theraputicAreaConstant } from 'src/app/constants/service.constants';
import * as $ from 'jquery';
import { DeleteBoxComponent } from '../../../common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { AvailableNetworklocationsComponent } from '../../available-networklocations/available-networklocations.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-view-modal',
  templateUrl: './product-view-modal.component.html',
  styleUrls: ['./product-view-modal.component.scss']
})
export class ProductViewModalComponent implements OnInit {

  formFields;

  optionsSelect = studyReportPatientConstant;
  theraputicAreaOptions = theraputicAreaConstant;
 @Input() public Content: any;
  isautocode: boolean = false;
  strflag: string = null;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  productViewForm: UntypedFormGroup;
  TheraputicAreaList: any[];
  ProgramList: any[];
  DOSAGEFORMULATIONList: any[];
  StrengthUnitsList: any[];
  ProductApprovals: any = [];
  MappedItems: any = [];
  IsClicked:boolean= false;
  MappedLocationsCount: any = "0";
  MappedLocations: any = "";
  MappedLocatns: any = [];
  tooltipValue : any;

  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService
  ) {
  }
   ngOnInit() {
    this.IsAutoCodeConfigured();
    this.GetMasterData();
    this.productViewForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        CODE: new UntypedFormControl("", [Validators.required, Validators.maxLength(25)]),
        NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
        DOSAGEFORMULATION: new UntypedFormControl(""),
        STRENGTH: new UntypedFormControl(""),
        UNITS: new UntypedFormControl(""),
        THERAPUETIC_AREA_ID: new UntypedFormControl(""),
        PROGRAM_ID: new UntypedFormControl(""),
        DRUG_CODE: new UntypedFormControl(""),
        PRODUCT_CODE: new UntypedFormControl(""),
        IS_ALLOW_SHIPMENT: new UntypedFormControl(false),
        IS_ALLOW_AUTHORISED: new UntypedFormControl(false),
        STORAGE_INSTRUCTIONS: new UntypedFormControl(""),
        IS_ACTIVE: new UntypedFormControl(true),
      });
     
    if (this.Content.heading == "View") {
      this.edit();
      this.productViewForm.disable();
    }
    if (this.Content.heading == "Edit") {
      this.edit();
    }
    // if (this.Content.heading === 'Add') { //Add mode 
    //   this.Content.content.id = this.commonService.getUniqueId();
    // }
  }

  private IsAutoCodeConfigured(): any {
    var featureid = "603";
    var orgid = this.userService.getOrganizationId();
    this.commonService.isAutocodeConfigured(featureid, orgid).subscribe((result) => {
      if (result == true) {
        this.isautocode = true;
      }
      else {
        this.isautocode = false;
      }
    });
  }

  GetMasterData() {
    this.TheraputicAreaList = [];
    this.ProgramList = [];
    this.DOSAGEFORMULATIONList = [];
    this.StrengthUnitsList = [];
   
    this.summaryService.GetMasterScreenData("api/Product/GetMasterScreenData?RecordID=" + this.Content.content.id).subscribe(summary => {
      this.TheraputicAreaList = summary["MasterData1"];
      this.ProgramList = summary["MasterData2"];
      this.ProgramList.forEach((item: any) =>
        {
            if(item.IsActive == false)
            item["icon"]="ieg_inactive_record";
        });
        
      this.DOSAGEFORMULATIONList = summary["MasterData4"];
      this.StrengthUnitsList = summary["MasterData5"];
      this.TheraputicAreaList = [{ label: "Select", value: "", checked: true }].concat(this.TheraputicAreaList);
      this.DOSAGEFORMULATIONList = [{ label: "Select", value: "", checked: true }].concat(this.DOSAGEFORMULATIONList);
      this.StrengthUnitsList = [{ label: "Select", value: "", checked: true }].concat(this.StrengthUnitsList);
/*       this.ProgramList=  [{label:"All",value:"-1", checked: true}].concat(this.ProgramList);
 */    });
  }

  edit(): void {
    this.summaryService.getRecord('api/Product/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
      this.ProductApprovals = summary["ChildData"];
      this.MappedItems = summary["MappedItems"];
      this.productViewForm.patchValue({
        ID: summary["Modal"]["ID"],
        CODE: summary["Modal"]["CODE"],
        NAME: summary["Modal"]["NAME"],
        DOSAGEFORMULATION: summary["Modal"]["DOSAGEFORMULATION"],
        STRENGTH: summary["Modal"]["STRENGTH"],
        UNITS: summary["Modal"]["UNITS"],
        THERAPUETIC_AREA_ID: summary["Modal"]["THERAPUETIC_AREA_ID"],
        DRUG_CODE: summary["Modal"]["DRUG_CODE"],
        PRODUCT_CODE: summary["Modal"]["PRODUCT_CODE"],
        IS_ALLOW_SHIPMENT: summary["Modal"]["IS_ALLOW_SHIPMENT"],
        IS_ALLOW_AUTHORISED: summary["Modal"]["IS_ALLOW_AUTHORISED"],
        STORAGE_INSTRUCTIONS: summary["Modal"]["STORAGE_INSTRUCTIONS"],
        IS_ACTIVE: summary["Modal"]["RECORD_STATE"] == 1 ? true : false,
      });

      var formData = this.productViewForm.getRawValue();
      if (summary["MappedItems"].length > 0) {
        summary["MappedItems"].forEach((element: any) => {
          this.MappedLocatns.push(element.Value);
          if (formData["MAPPED_LOCATIONS"] != null && formData["MAPPED_LOCATIONS"] != undefined) {
            formData["MAPPED_LOCATIONS"] = element.Value;
          } else {
            formData["MAPPED_LOCATIONS"] = formData["MAPPED_LOCATIONS"] + "|" + element.Value;
          }
        });

      }
      this.productViewForm.controls["NAME"].disable();  ;
      if (summary["Modal"]["PROGRAM_ID"] != null && summary["Modal"]["PROGRAM_ID"] != undefined && summary["Modal"]["PROGRAM_ID"] != "") {
        let abc = summary["Modal"]["PROGRAM_ID"].split(",");

        abc = abc.filter((product) => product!=null && (product!=undefined && product.length>10));
       
        this.productViewForm.controls["PROGRAM_ID"].setValue(abc);
      }
      else 
      { 
      this.productViewForm.controls["PROGRAM_ID"].setValue([]);
     }
       this.changeVal(null);
      //document.body.click();
    });
  }

  changeVal($event) {
    setTimeout(()=>{
    let selectedProducts= this.productViewForm.controls["PROGRAM_ID"].value;
    if(selectedProducts != "" && selectedProducts != undefined && selectedProducts != null)
      {
        let productLabel=this.ProgramList.filter((item)=>{
          return  selectedProducts.indexOf(item.value)>-1;
         });
         let labellist=[];
         productLabel.forEach((item)=>{
           labellist.push(item.label);
         });
         this.tooltipValue =labellist.join(",");
      }
      else
      {
        this.tooltipValue = "";
      }
    },200);
  } 

  ClosePopup() {
  //  this.action.next();
    this.modalRef.close();
  }
  mapLocations() {
    {
      if (this.productViewForm.controls["ID"].value == "") { this.strflag = "N" }
      else { this.strflag = "E" }
      let modalRef = this.modalService.open(AvailableNetworklocationsComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: this.Content.heading,
        content: { id: this.productViewForm.controls["ID"].value, flag: this.strflag, mappedIds: this.MappedLocatns }
      }
      modalRef.result.then((result: any) => {
        this.MappedLocatns=[];
        this.MappedItems=[];
        result.forEach(element => {
          if(this.MappedLocatns.indexOf(element.Value)==-1){
            this.MappedItems.push(element);
            this.MappedLocatns.push(element.Value);
          }
        });        
      });
    }

  }

  DeleteMapLoc(item): void {
    let index = this.MappedItems.findIndex((element) => element.Value == item);
    this.MappedItems.splice(index, 1);
    let index1 = this.MappedLocatns.findIndex((element) => element == item);
    this.MappedLocatns.splice(index1,1);
  }
  SaveProductDetails() {
    
    //if (this.IsClicked == false) {
    //  this.IsClicked = true;
    if (this.validateControls()) {
     // var formData = this.productViewForm.getRawValue();
     var formData=this.productViewForm.value;
      formData.STRENGTH = parseInt(formData.STRENGTH);
      //formData.RECORD_STATE=this.productViewForm.controls["IS_ACTIVE"].value ? 1 : 0;
      formData.RECORD_STATE = formData.IS_ACTIVE == true ? 1 : 0;
      formData["MAPPED_LOCATIONS"]=[];
      if(this.MappedItems.length>0){
        this.MappedItems.sort((a, b) => a.Text-b.Text);
        this.MappedItems.forEach(obj => {
          if (formData["MAPPED_LOCATIONS"] == "") {
            formData["MAPPED_LOCATIONS"] = obj.Value;
            formData.MAPPEDLOCNAME = obj.Text;
          }
          else {
            formData["MAPPED_LOCATIONS"] = formData.MAPPED_LOCATIONS + "|" + obj.Value;
            formData.MAPPEDLOCNAME = formData.MAPPEDLOCNAME + ", " + obj.Text;
          }
          formData["MAPPED_LOCATIONS"]=[...new Set(formData.MAPPED_LOCATIONS.split(","))].join(",");
        });
      }
      else{
        formData["MAPPED_LOCATIONS"]="";
      }
     

      var DFobj = this.DOSAGEFORMULATIONList.filter(function (element) {

        return element.value == formData.DOSAGEFORMULATION;
      })[0];
      if (DFobj != null && DFobj != undefined) {
        formData["DOSAGEFORMULATIONNAME"] = DFobj.label;
      }
      else {
        formData["DOSAGEFORMULATIONNAME"] = "";
      }

      var TAobj = this.TheraputicAreaList.filter(function (element) {
        return element.value == formData.THERAPUETIC_AREA_ID;
      })[0];

      if (TAobj != null && TAobj != undefined && TAobj.label !="Select")  {
        formData["THERAPUTICAREANAME"] = TAobj.label;
      }
      else {
        formData["THERAPUTICAREANAME"] = "";
      }

      var SUobj = this.StrengthUnitsList.filter(function (element) {
        return element.value == formData.UNITS;
      })[0];
      if (SUobj != null && SUobj != undefined) {
        formData["UNITNAME"] = SUobj.label;
      }
      else {
        formData["UNITNAME"] = "";
      }
      var PROGobj = this.ProgramList.filter(function (element) {
        return formData.PROGRAM_ID.indexOf(element.value) > -1;
      });
      if (PROGobj.length > 0) {
        let names = PROGobj.map(x => x.label).join(",");
        let proIDs =PROGobj.map(x => x.value).join(",");
        formData["PROGRAMNAME"] = names;
        formData.PROGRAM_ID = proIDs;
      }
      else { formData.PROGRAM_ID ="";}
      if (this.Content.heading == "Add") {
        formData.NAME=formData.NAME==null?null:formData.NAME==undefined?undefined:formData.NAME.trim();
        //formData["ID"] = this.Content.content.id;
        this.summaryService.Insert('api/Product/Insert', formData).subscribe(summary => {
          if (summary.Status === 0) {
            this.commonService.SuccessBanner(summary.Message);
           // this.action.next();
            this.modalRef.close();
            this.productViewForm.controls["ID"].setValue(this.Content.content.id);
            // this.Content.heading = "Edit";
            // this.IsClicked = false
          }
          else {
            this.commonService.ValidationBanner(summary.Message);
            //              this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: summary.Message } } });
          }

        });
      }
      else {
        
        formData.NAME=this.productViewForm.controls["NAME"].value;
        this.summaryService.Insert('api/Product/Update', formData).subscribe(summary => {
          if (summary.Status == 0) {
            this.commonService.SuccessBanner(summary.Message);
          //  this.action.next();
            this.modalRef.close();
            this.IsClicked = false
          }
          else {
            
            //this.commonService.ErrorBanner(summary.Message);
            this.commonService.ValidationBanner(summary.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: summary.Message } } });
          }
        });
      }

    }
    //}

  }

  addDocuments(event) {
    if (this.productViewForm.controls["ID"].value == "") {
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Please Save Record before Adding Approvals.' } } });
      this.commonService.ValidationBanner("Please Save Record before Adding Approvals");
    } else {
      let modalRef = this.modalService.open(AddProductApprovalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: "Add",
        content: { id: this.productViewForm.controls["ID"].value }
      }
      modalRef.result.then(result => {
        this.summaryService.GetMasterScreenData('api/Product/ProductAgainstApprovals?ProductID=' + this.productViewForm.controls["ID"].value).subscribe(summary => {
          this.ProductApprovals = summary;

        });
      });
    }
  }


  EditDocuments(ID) {
    var modalRef = this.modalService.open(AddProductApprovalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: ID }
    }
    modalRef.result.then(result => {
      this.summaryService.GetMasterScreenData('api/Product/ProductAgainstApprovals?ProductID=' + this.productViewForm.controls["ID"].value).subscribe(summary => {
      this.ProductApprovals = summary;

      });

    });
  }

  DeleteDocuments(ID) {
    let modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false});
    modalRef.result.then(result => {
      this.summaryService.Delete('api/Product/DeleteProductAPprovals?ApprovalID=' + ID).subscribe(summary => {
      
        this.summaryService.GetMasterScreenData('api/Product/ProductAgainstApprovals?ProductID=' + this.productViewForm.controls["ID"].value).subscribe(summary => {
          this.ProductApprovals = summary;

        });
      });
    });
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.productViewForm.getRawValue();

    /* if (this.isautocode == false) {
      if (formData.CODE === null || formData.CODE === "" || formData.CODE === undefined) {
        $("#CODE").addClass("ng-touched ng-invalid validate-error");
        $("#CODE").removeClass("ng-untouched ng-valid");
        message += "Please enter Code.<br/>";
        isValid = false;
      } else {
        $("#CODE").addClass("ng-untouched ng-valid");
        $("#CODE").removeClass("ng-touched ng-invalid validate-error");
      }
    } */

    if (formData.NAME === null || formData.NAME === "" || formData.NAME === undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name<br/>";
      isValid = false;
    }else if((formData.NAME !=null && formData.NAME != undefined)&&(formData.NAME.trim()=="")){
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name<br/>";
      isValid = false;
    } 
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.DOSAGEFORMULATION === null || formData.DOSAGEFORMULATION === "-1" || formData.DOSAGEFORMULATION === "" || formData.DOSAGEFORMULATION === undefined) {
      $("#DOSAGEFORMULATION").addClass("ng-touched ng-invalid validate-error");
      $("#DOSAGEFORMULATION").removeClass("ng-untouched ng-valid");
      message += "Please select Dosage Formulation<br/>";
      isValid = false;
    } else {
      $("#DOSAGEFORMULATION").addClass("ng-untouched ng-valid");
      $("#DOSAGEFORMULATION").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.STRENGTH === null || formData.STRENGTH === "" || formData.STRENGTH === "-1" || formData.STRENGTH === undefined) {
      $("#STRENGTH").addClass("ng-touched ng-invalid validate-error");
      $("#STRENGTH").removeClass("ng-untouched ng-valid");
      message += "Please enter Strength<br/>";
      isValid = false;
    } else {
      $("#STRENGTH").addClass("ng-untouched ng-valid");
      $("#STRENGTH").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.UNITS === null || formData.UNITS === "" || formData.UNITS === "-1" || formData.UNITS === undefined) {
      $("#UNITS").addClass("ng-touched ng-invalid validate-error");
      $("#UNITS").removeClass("ng-untouched ng-valid");
      message += "Please select Units<br/>";
      isValid = false;
    } else {
      $("#UNITS").addClass("ng-untouched ng-valid");
      $("#UNITS").removeClass("ng-touched ng-invalid validate-error");
    }

    /* if (formData.STORAGE_INSTRUCTIONS === null || formData.STORAGE_INSTRUCTIONS === "" || formData.STORAGE_INSTRUCTIONS === undefined) {
      $("#STORAGE_INSTRUCTIONS").addClass("ng-touched ng-invalid validate-error");
      $("#STORAGE_INSTRUCTIONS").removeClass("ng-untouched ng-valid");
      message += "Please enter Storage Instructions.<br/>";
      isValid = false;
    } else {
      $("#STORAGE_INSTRUCTIONS").addClass("ng-untouched ng-valid");
      $("#STORAGE_INSTRUCTIONS").removeClass("ng-touched ng-invalid validate-error");
    } */


    if (!isValid) {
      this.commonService.ValidationBanner(message);
      //      this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Messge(s)', content: { heading: '', description: message } } });
      this.IsClicked = false
    } return isValid;
  }
}
